import { SCHEDULE_STATUS_COLORS } from "./constants";
import { TaskCalendarStatus } from "./types";

export const getScheduleEventColor = (
  status: TaskCalendarStatus
): { bg: string; text: string } => {
  if (status === TaskCalendarStatus.PENDING) {
    return {
      bg: SCHEDULE_STATUS_COLORS[status],
      text: "text-black",
    };
  }
  return {
    bg: SCHEDULE_STATUS_COLORS[status] ?? "bg-gray-400",
    text: "text-white",
  };
};

export const getScheduleStatusTextColor = (status: TaskCalendarStatus) =>
  status === TaskCalendarStatus.PENDING ? "text-black" : "text-white";
